module.exports = __webpack_public_path__ + "static/media/create_bm.db4dfcbd.svg";